import { Check, KeyboardArrowDownRounded } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";

type Option = {
  name: string;
  value: string | number;
  url?: string;
};

type Props = {
  buttonText?: string;
  options: Array<Option>;
  onChange: (value: string | number) => void;
  showAll?: boolean;
  drawerOpen?: boolean; // <-- Add this prop
  value?: string | number; // <-- Add this prop to control the selected value
};

const PopoverSelect = ({
  buttonText = "Open",
  onChange,
  options,
  showAll = false,
  drawerOpen = true, // <-- Default to true
  value,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedOption, setSelectedOption] = useState<string | number>(
    value || "",
  );

  useEffect(() => {
    if (value !== undefined && value !== null) {
      setSelectedOption(value);
    }
  }, [value]);

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleChange = useCallback(
    (option: Option) => () => {
      setSelectedOption(option.value);
      onChange(option.value);
      handleClose();
    },
    [handleClose, onChange],
  );

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Grid>
      <Tooltip
        placement="right"
        title={
          <Typography variant="body1">
            {options.find((e) => e.value === selectedOption)?.name ||
              buttonText}
          </Typography>
        }
        disableHoverListener={drawerOpen}
        disableFocusListener={drawerOpen}
        disableTouchListener={drawerOpen}
      >
        <Button
          aria-describedby={id}
          variant="text"
          onClick={handleClick}
          endIcon={drawerOpen ? <KeyboardArrowDownRounded /> : undefined} // <-- Only show arrow when open
        >
          {selectedOption ? (
            <>
              <Avatar
                alt={options.find((e) => e.value === selectedOption)?.name}
                src={options.find((e) => e.value === selectedOption)?.url}
                className="company_logo"
              />
              {drawerOpen && (
                <span style={{ marginLeft: 8 }}>
                  {options.find((e) => e.value === selectedOption)?.name}
                </span>
              )}
            </>
          ) : (
            buttonText
          )}
        </Button>
      </Tooltip>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {showAll && (
          <MenuItem
            value={""}
            selected={selectedOption === ""}
            onClick={handleChange({
              name: "All",
              value: "",
              url: "",
            })}
          >
            {selectedOption === "" && (
              <ListItemIcon>
                <Check />
              </ListItemIcon>
            )}
            <ListItemText>All</ListItemText>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            value={option.value}
            key={option.value}
            selected={selectedOption === option.value}
            onClick={handleChange(option)}
            sx={{
              gap: 1,
            }}
          >
            {selectedOption === option.value && (
              <ListItemIcon>
                <Check />
              </ListItemIcon>
            )}
            {option.url && (
              <Avatar
                alt={option?.name}
                src={option?.url}
                className="company_logo"
              />
            )}
            <ListItemText
              style={{
                textTransform: "none",
                fontWeight: "500",
                lineHeight: "20px",
                fontSize: "14px",
              }}
            >
              {option.name}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
};

export default PopoverSelect;
